import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { I18nProvider } from "@/context/I18nContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import ApprovePasswordChange from "@/pages/ApprovePasswordChange";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import Dashboard from "@/pages/Dashboard";
import Personnel from "@/pages/Personnel";
import PendingApprovals from "@/pages/PendingApprovals";
import Leaves from "@/pages/Leaves";
import Payroll from "@/pages/Payroll";
import Messages from "@/pages/Messages";
import Announcements from "@/pages/Announcements";
import CalendarPage from "@/pages/CalendarPage";
import Reports from "@/pages/Reports";
import Notifications from "@/pages/Notifications";
import SettingsPage from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import Shifts from "@/pages/Shifts";
import Surveys from "@/pages/Surveys";
import Reconciliation from "@/pages/Reconciliation";
import PayrollAdmin from "@/pages/PayrollAdmin";
import Promotions from "@/pages/Promotions";
import NormCadre from "@/pages/NormCadre";
import HRCenter from "@/pages/HRCenter";
import MonthlyLeaves from "@/pages/MonthlyLeaves";
import Guide from "@/pages/Guide";
import Delegations from "@/pages/Delegations";

function App() {
  useEffect(() => {
    // Register service worker for PWA
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    }
  }, []);

  return (
    <div className="App">
      <ThemeProvider>
        <I18nProvider>
          <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/approve-password-change/:token" element={<ApprovePasswordChange />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfUse />} />
              <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
                <Route index element={<Dashboard />} />
                <Route path="personnel" element={<Personnel />} />
                <Route path="pending" element={<ProtectedRoute roles={["admin", "hr"]}><PendingApprovals /></ProtectedRoute>} />
                <Route path="leaves" element={<Leaves />} />
                <Route path="leaves/reconciliation" element={<Reconciliation />} />
                <Route path="shifts" element={<Shifts />} />
                <Route path="payroll" element={<Payroll />} />
                <Route path="messages" element={<Messages />} />
                <Route path="announcements" element={<Announcements />} />
                <Route path="calendar" element={<CalendarPage />} />
                <Route path="surveys" element={<Surveys />} />
                <Route path="reports" element={<ProtectedRoute roles={["admin", "hr", "gm", "manager"]}><Reports /></ProtectedRoute>} />
                <Route path="audit" element={<ProtectedRoute roles={["admin", "hr"]}><AuditLog /></ProtectedRoute>} />
                <Route path="notifications" element={<Notifications />} />
                <Route path="settings" element={<SettingsPage />} />
                <Route path="payroll-admin" element={<ProtectedRoute roles={["admin", "hr", "gm"]}><PayrollAdmin /></ProtectedRoute>} />
                <Route path="promotions" element={<Promotions />} />
                <Route path="norm-cadre" element={<ProtectedRoute roles={["admin", "hr", "gm", "manager"]}><NormCadre /></ProtectedRoute>} />
                <Route path="hr-center" element={<ProtectedRoute roles={["admin", "hr", "gm"]}><HRCenter /></ProtectedRoute>} />
                <Route path="reports/monthly-leaves" element={<ProtectedRoute roles={["admin", "hr", "gm"]}><MonthlyLeaves /></ProtectedRoute>} />
                <Route path="guide" element={<Guide />} />
                <Route path="delegations" element={<ProtectedRoute roles={["admin", "hr", "gm", "manager"]}><Delegations /></ProtectedRoute>} />
              </Route>
            </Routes>
            <Toaster position="bottom-right" />
          </AuthProvider>
        </BrowserRouter>
        </I18nProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
